module.exports = __webpack_public_path__ + "static/media/nocase.55710376.svg";